module.exports = __webpack_public_path__ + "img/img45.e8e18382.png";